/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Last_ActiveInputs */

const th_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ใช้งานล่าสุด ${i?.when}`)
};

const en_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`last active ${i?.when}`)
};

const ja_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最終利用 ${i?.when}`)
};

const zh_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最后活跃于 ${i?.when}`)
};

const es_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`última actividad ${i?.when}`)
};

const pt_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`última atividade ${i?.when}`)
};

const id_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`terakhir aktif ${i?.when}`)
};

const fr_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`dernière activité ${i?.when}`)
};

const tl_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`huling aktibo ${i?.when}`)
};

const vi_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`hoạt động lần cuối ${i?.when}`)
};

const ko_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`마지막 활동 ${i?.when}`)
};

const de_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`zuletzt aktiv ${i?.when}`)
};

const ru_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`последняя активность ${i?.when}`)
};

const tr_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`son etkinlik ${i?.when}`)
};

const it_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ultima attività ${i?.when}`)
};

const pl_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ostatnia aktywność ${i?.when}`)
};

const uk_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`остання активність ${i?.when}`)
};

const hi_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अंतिम गतिविधि ${i?.when}`)
};

const ar_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`آخر نشاط ${i?.when}`)
};

const ms_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`aktif kali terakhir ${i?.when}`)
};

const bn_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`সর্বশেষ সক্রিয় ${i?.when}`)
};

const zh_tw2_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最後活動於 ${i?.when}`)
};

const zh_hk2_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最後活動於 ${i?.when}`)
};

const ur_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`آخری سرگرمی ${i?.when}`)
};

const fa_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`آخرین فعالیت ${i?.when}`)
};

const sw_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`alikuwa hai mwisho ${i?.when}`)
};

const nl_last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`laatst actief ${i?.when}`)
};

/**
* | output |
* | --- |
* | "last active {when}" |
*
* @param {Last_ActiveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_active = /** @type {((inputs: Last_ActiveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_ActiveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_last_active(inputs)
	if (locale === "ja") return ja_last_active(inputs)
	if (locale === "zh") return zh_last_active(inputs)
	if (locale === "es") return es_last_active(inputs)
	if (locale === "pt") return pt_last_active(inputs)
	if (locale === "id") return id_last_active(inputs)
	if (locale === "fr") return fr_last_active(inputs)
	if (locale === "tl") return tl_last_active(inputs)
	if (locale === "vi") return vi_last_active(inputs)
	if (locale === "ko") return ko_last_active(inputs)
	if (locale === "de") return de_last_active(inputs)
	if (locale === "ru") return ru_last_active(inputs)
	if (locale === "tr") return tr_last_active(inputs)
	if (locale === "it") return it_last_active(inputs)
	if (locale === "pl") return pl_last_active(inputs)
	if (locale === "uk") return uk_last_active(inputs)
	if (locale === "hi") return hi_last_active(inputs)
	if (locale === "ar") return ar_last_active(inputs)
	if (locale === "ms") return ms_last_active(inputs)
	if (locale === "bn") return bn_last_active(inputs)
	if (locale === "zh-TW") return zh_tw2_last_active(inputs)
	if (locale === "zh-HK") return zh_hk2_last_active(inputs)
	if (locale === "ur") return ur_last_active(inputs)
	if (locale === "fa") return fa_last_active(inputs)
	if (locale === "sw") return sw_last_active(inputs)
	if (locale === "nl") return nl_last_active(inputs)
	return en_last_active(inputs)
});